export default __webpack_public_path__ + "static/media/wallet_status.51dc98ab.svg";